import { incrementDate } from '../../utils';
import { DefaultTestLocationGroupList, LocationGroup } from './locationGroup';

export interface SlotDateGroup {
  appointmentDate?: Date;
  locationGroupList?: LocationGroup[];
}

///////////////////////////////////////////////
// defaults for testing
export const DefaultTestAvailableAppointmentSlots: SlotDateGroup[] = new Array(
  4
)
  .fill(undefined)
  .map((item, index) => ({
    appointmentDate: incrementDate(new Date(2024, 4, 31), index),
    locationGroupList: DefaultTestLocationGroupList,
  }));
